export const getSetupMFATOTP = state => state.setupMFATOTP
